import { render } from "./TongHangDetail.vue?vue&type=template&id=69f96c9f&scoped=true"
import script from "./TongHangDetail.vue?vue&type=script&lang=js"
export * from "./TongHangDetail.vue?vue&type=script&lang=js"

import "./TongHangDetail.vue?vue&type=style&index=0&id=69f96c9f&scoped=true&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f96c9f"]])

export default __exports__